module.exports = __webpack_public_path__ + "static/Remy-8abd9e7b583202aaa0308eccfa7cc486.png";